// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"da3a5708","799":"8e5e0375","883":"62ec348a","943":"230dec1c","956":"dc91732a","968":"f07bdf27"}[chunkId] + ".chunk.js";
};